import { htmlToADF } from '@atlassian/html-adf-transformer';

import type { IssueObject } from '../providers/BulkCreateContextProvider';

export const convertNodeToElement = (node: Node): Element | null => {
	return node.nodeType === Node.ELEMENT_NODE ? (node as HTMLElement) : node.parentElement;
};

export const findActionItemElement = (node: Node): HTMLDivElement | null => {
	const element = convertNodeToElement(node);
	return element?.closest('[data-task-local-id]') ?? null;
};

export const includeEntireActionItemInSelection = (selection: Selection | null | undefined) => {
	if (!selection || selection.rangeCount === 0) {
		return selection;
	}
	const range = selection.getRangeAt(0);
	const { startContainer, endContainer } = range;

	const startInActionItem = findActionItemElement(startContainer);
	const endInActionItem = findActionItemElement(endContainer);
	if (startInActionItem) {
		const newRange = document.createRange();
		newRange.selectNodeContents(startInActionItem);
		return newRange;
	}
	if (endInActionItem) {
		const newRange = document.createRange();
		newRange.selectNodeContents(endInActionItem);
		return newRange;
	}
	return range;
};

export const getClosestActionListFromSelection = (selection: Selection | null | undefined) => {
	if (!selection || selection.rangeCount === 0) {
		return null;
	}
	const range = selection.getRangeAt(0);
	const container = convertNodeToElement(range.commonAncestorContainer);
	if (!container) {
		return null;
	}

	const actionItems = Array.from(
		container.querySelectorAll('div[data-task-local-id]:not([data-task-local-id=""])'),
	);
	const firstActionItemInSelection =
		actionItems.find((actionItem) => range.intersectsNode(actionItem)) ?? null;

	const allLists = Array.from(document.querySelectorAll('[aria-label="Action Item List"]'));
	return allLists.find((list) => list.contains(firstActionItemInSelection)) ?? null;
};

export const mapActionItemsToIssues = (actionList: Element) => {
	// Skip if any child has data-task-list-local-id -> avoid double counting nested action items
	const actionItems = actionList?.querySelectorAll(
		'div[data-task-local-id]:not([data-task-local-id=""]):not(:has([data-task-list-local-id]))',
	);
	const issues: IssueObject[] = [];
	let issueIndex = 0;
	actionItems.forEach((actionItem) => {
		if (actionItem.textContent?.trim()) {
			const issue: IssueObject = {
				id: String(issueIndex),
				issueType: {
					iconUrl: '',
					name: '',
					id: '',
				},
				rowIndex: issueIndex,
				summary: actionItem.textContent.trim(),
				description: htmlToADF(actionItem.innerHTML),
			};
			issues.push(issue);
		}
		issueIndex++;
	});

	return issues;
};
